import { clsx } from 'clsx';

import styles from './SignupLayout.module.css';
import BackToStep from '../BackToStep/BackToStep';
import MyAccount from '../MyAccount/MyAccount';

const SignupLayoutHeadingDirectUK = () => {
  return (
    <nav className={clsx(styles.navContainer, styles.directCustomerNav)}>
      <BackToStep />
      <MyAccount />
    </nav>
  );
};

export default SignupLayoutHeadingDirectUK;
